import { FunctionComponent } from 'react';

import Slide from '../components/Slide';
import Digest0 from '../components/digests/Digest0';
import Digest1 from '../components/digests/Digest1';
import Digest2 from '../components/digests/Digest2';
import Digest3 from '../components/digests/Digest3';
import Digest4 from '../components/digests/Digest4';
import Digest5 from '../components/digests/Digest5';
import Digest6 from '../components/digests/Digest6';
import Digest7 from '../components/digests/Digest7';
import Digest10 from '../components/digests/Digest10';
import Digest11 from '../components/digests/Digest11';
import Digest12 from '../components/digests/Digest12';
import Digest13 from '../components/digests/Digest13';
import Digest14 from '../components/digests/Digest14';
import Digest15 from '../components/digests/Digest15';

const cfg = require('../../common/cfg');

const prefix = cfg.urlPrefix;
const getFullUrl = (url: string) => {
  if (url.startsWith('/')) {
    return `${prefix}${url.replace(/^\//, '')}`;
  }
  return `${prefix}mobile/${url}`;
};

export type Config = {
  slides: Array<{
    component: FunctionComponent<any>;
    digest?: FunctionComponent<any>;
    svgMovie?: any;
    videos?: Array<any>;
    svgs?: Array<string>;
    images?: Array<string>;
  }>;
  prefix: string;
  getFullUrl: (url: string) => string;
  debug?: boolean;
};

const config: Config = {
  slides: [
    {
      component: Slide, // 0
      digest: Digest0,
      svgMovie: getFullUrl('svg/slide01.json'),
    },
    {
      component: Slide, // 1
      digest: Digest1,
      svgMovie: getFullUrl('svg/slide02.json'),
      svgs: [getFullUrl('svg/slide02-q.json')],
      videos: [],
    },
    {
      component: Slide, // 2
      digest: Digest2,
      videos: [
        {
          src: getFullUrl('videos/slide03.mp4'),
          poster: getFullUrl('posters/slide03.png'),
          autoPlay: false,
        },
      ],
      images: [getFullUrl('images/logo-q.svg')],
    },
    {
      component: Slide, // 3
      digest: Digest3,
      videos: [
        {
          src: getFullUrl('videos/slide04.mp4'),
          autoPlay: false,
        },
      ],
      images: [getFullUrl('images/logo-q.svg')],
    },
    {
      component: Slide, // 4
      digest: Digest4,
      images: [getFullUrl('images/logo-q.svg')],
      videos: [
        {
          src: getFullUrl('videos/slide05.mp4'),
          poster: getFullUrl('posters/slide05.png'),
          autoPlay: false,
        },
      ],
    },
    {
      component: Slide, // 5
      digest: Digest5,
      videos: [
        {
          src: getFullUrl('videos/slide06.mp4'),
          poster: getFullUrl('posters/slide06.png'),
          autoPlay: false,
        },
      ],
    },
    {
      component: Slide, // 6
      digest: Digest6,
      videos: [
        {
          src: getFullUrl('videos/slide07.mp4'),
          poster: getFullUrl('posters/slide07.png'),
          autoPlay: false,
        },
      ],
      svgs: [getFullUrl('svg/slide08.json')],
      images: [getFullUrl('images/logo-q.svg')],
    },
    {
      component: Slide, // 7
      digest: Digest7,
      svgs: [getFullUrl('svg/slide08.json')],
      videos: [
        {
          src: getFullUrl('videos/slide08.mp4'),
          poster: getFullUrl('posters/slide08.png'),
          autoPlay: false,
        },
      ],
    },
    {
      component: Slide, // 8
      videos: [
        {
          src: getFullUrl('videos/slide09-10.mp4'),
          poster: getFullUrl('posters/slide09.png'),
          autoPlay: false,
          autoPlayNext: true,
        },
        // {
        //   src: getFullUrl('videos/slide10.mp4'),
        //   autoPlay: false,
        //   loop: true,
        // },
      ],
    },
    {
      component: Slide, // 9
      videos: [
        {
          src: getFullUrl('videos/slide11.mp4'),
          poster: getFullUrl('posters/slide11.png'),
          autoPlay: false,
        },
      ],
    },
    {
      component: Slide, // 10
      svgMovie: getFullUrl('svg/slide12.json'),
      digest: Digest10,
    },
    {
      component: Slide, // 11
      digest: Digest11,
      svgMovie: getFullUrl('svg/slide13.json'),
      svgs: [getFullUrl('svg/slide13-percent-40.json')],
      videos: [],
    },
    {
      component: Slide, // 12
      digest: Digest12,
      svgMovie: getFullUrl('svg/slide14.json'),
      images: [getFullUrl('images/3-ends.svg')],
    },
    {
      component: Slide, // 13
      digest: Digest13,
      svgMovie: getFullUrl('svg/slide15.json'),
      svgs: [getFullUrl('svg/slide15-percent-20.json')],
    },
    {
      component: Slide, // 14
      digest: Digest14,
      svgMovie: getFullUrl('svg/slide16.json'),
      svgs: [getFullUrl('svg/slide16-1-to-infinite.json')],
    },
    {
      component: Slide, // 15
      digest: Digest15,
      svgMovie: getFullUrl('svg/slide17.json'),
    },
  ],
  prefix,
  getFullUrl,
  debug: cfg.debug,
};

export default config;
